import { useCallback, useEffect, useState } from 'react';

import type { PaymentItemId, PaymentRequestType } from '../../../generated-types';
import { OutboxWrapper } from '../../../models/outbox';
import { sign } from '../../../services/outboxService';
import { useSigningContext } from '../../../signingContext/signingContext';
import { Actions } from '../../../signingContext/signingTypes';

export default () => {
    const [invalidatePending, setInvalidatePending] = useState(false);
    const { signingOperationPending, signingCompleted, showSigningFlow, startSigning, dispatch, signingError } =
        useSigningContext(sign);

    useEffect(() => {
        if (signingCompleted && invalidatePending) {
            setInvalidatePending(false);
            dispatch({ type: Actions.CLEAR_ERROR });
        }
    }, [signingOperationPending, dispatch, invalidatePending, signingCompleted]);

    const onApproveSingleOutboxItem = useCallback(
        (type: PaymentRequestType) => (id: PaymentItemId) => {
            const request = { id, type };
            setInvalidatePending(true);
            startSigning({ singlePayment: request });
        },
        [startSigning],
    );

    const onApproveOutboxItems = useCallback(
        (selectedItems: OutboxWrapper[]) => {
            const request = {
                ids: selectedItems.map((item) => item.paymentItemId),
            };
            setInvalidatePending(true);
            startSigning({ bulkPayment: request });
        },
        [startSigning],
    );

    const showModal = showSigningFlow || !!signingError || signingCompleted;

    return {
        showModal,
        onApproveOutboxItems,
        onApproveSingleOutboxItem,
    };
};
